<!-- 开通VIP -->
<template>
  <div class="buyvip">
    <div class="header-bg"></div>
    <div class="header">
      <user-card class="usercard" />
    </div>
    <vip-pkg class="vip-pkg" @goodsSelected="onGoodsSelected" />
    <app-privilege class="privilege" />
    <footer-pay-bar class="paybar" :goodsInfo="activeGoods" />
  </div>
</template>

<script>
import UserCard from '@/components/UserCard/index'
import AppPrivilege from '@/views/buyvip/privilege'
import VipPkg from '@/views/buyvip/vipPkg'
import FooterPayBar from '@/components/FooterPayBar/index'

export default {
  components: { UserCard, AppPrivilege, VipPkg, FooterPayBar },
  data () {
    return {
      activeGoods: null
    }
  },
  created () {
    
  },
  methods: {
    onGoodsSelected(data) {
      this.activeGoods = data
    }
  },
  computed: {
    
  },
  mounted () {
    
  }
}
</script>

<style scoped lang="less">
  @import "~@/styles/fn";
  .buyvip {
    position: relative;
    padding-top: .4rem;
    padding-bottom: 1.8rem;
  }
  .header-bg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2.8rem;
    .bg("~@/assets/buyvip/header-bg.png");
  }
  .header {
    margin-bottom: .48rem;
  }
  .vip-pkg {
    margin-bottom: .64rem;
  }
</style>
